import React, { Component } from "react";
import { Icon, Button } from "react-materialize";
import NuxeoClient from "../../clients/NuxeoClient";

import "./BulkDownload.css";

class BulkDownload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      allFiles: props.allFiles,
      isDownloading: false,
    };

    this._runDownloadAll = this._runDownloadAll.bind(this);
    this._runDownload = this._runDownload.bind(this);
    this._handleBulkDownloadComplete = this._handleBulkDownloadComplete.bind(
      this
    );

    this._externalHandlers = {
      bulkDownloadChanged: props.onBulkDownloadChanged,
    };
  }

  _handleBulkDownloadComplete() {
    this.setState({ isDownloading: false });
    this._externalHandlers.bulkDownloadChanged();
  }

  _runDownloadAll(title) {
    let allFileObjects = this.state.allFiles;
    this.setState({ isDownloading: true });

    if (this.state.allFiles) {
      let allFileList = [];

      allFileObjects["All Files"].map((file) => allFileList.push(file.uid));
      if (allFileList.length === 0) {
        window.Materialize.toast("No Assets Found...", 2000);
        return;
      }
      NuxeoClient.instance().startBulkDownload(
        `${title}.zip`,
        allFileList,
        this._handleBulkDownloadComplete
      );
    }
  }

  _runDownload(title, selectedFiles) {
    let inputFiles = [];

    selectedFiles.forEach((value, key) => {
      inputFiles.push(key);
    });
    if (inputFiles.length === 0) {
      window.Materialize.toast("No Assets Selected...", 2000);
      return;
    }
    this.setState({ isDownloading: true });
    NuxeoClient.instance().startBulkDownload(
      `${title}.zip`,
      inputFiles,
      this._handleBulkDownloadComplete
    );
  }

  render() {
    return (
      <div className="bulk-download">
        <div className="actions">
          <div
            style={{ display: !this.props.isBulkDownload ? "block" : "none" }}>
            <Button
              className="primary"
              waves="light"
              style={{ fontSize: "10px" }}
              onClick={() => {
                this._externalHandlers.bulkDownloadChanged();
              }}>
              Bulk Download
              <Icon left>file_download</Icon>
            </Button>
          </div>
          <div
            style={{ display: this.props.isBulkDownload ? "block" : "none" }}>
            <div className="layout horizontal">
              <div>
                <Button
                  className="btn-primary"
                  waves="light"
                  style={{ fontSize: "10px" }}
                  onClick={() => {
                    this._runDownloadAll(this.props.submissionTitle);
                  }}>
                  Download All
                  <Icon left>file_download</Icon>
                </Button>
              </div>
              <div>
                <Button
                  className="btn-primary"
                  waves="light"
                  style={{ fontSize: "10px" }}
                  onClick={() => {
                    this._runDownload(
                      this.props.submissionTitle,
                      this.props.selectedFiles
                    );
                  }}>
                  Download Selected
                  <Icon left>file_download</Icon>
                </Button>
              </div>
              <div>
                <Button
                  className="btn-primary"
                  waves="light"
                  style={{ fontSize: "10px" }}
                  onClick={() => {
                    this._externalHandlers.bulkDownloadChanged();
                  }}>
                  Back
                  <Icon left>close</Icon>
                </Button>
              </div>
            </div>
            <div className="selectioncount">
              {this.state.isDownloading ? "Downloading " : ""}
              {this.props.selectedFiles.size > 0
                ? this.props.selectedFiles.size + " selected"
                : ""}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BulkDownload;
